import {
  List,
  Datagrid,
  TextField,
  BooleanField,
  NumberField,
  DateField,
  EditButton,
  ShowButton,
  DeleteButton,
  BooleanInput,
  TextInput,
  Filter,
  TopToolbar,
  CreateButton,
  ExportButton,
} from 'react-admin';

const PrivacySectionFilter = (props: any) => (
  <Filter {...props}>
    <TextInput label="Search" source="q" alwaysOn />
    <BooleanInput label="Active" source="isActive" />
  </Filter>
);

const PrivacySectionListActions = () => (
  <TopToolbar>
    <CreateButton />
    <ExportButton />
  </TopToolbar>
);

export const PrivacySectionList = () => (
  <List
    filters={<PrivacySectionFilter />}
    actions={<PrivacySectionListActions />}
    sort={{ field: 'sortOrder', order: 'ASC' }}
  >
    <Datagrid>
      <NumberField source="id" />
      <TextField source="subtitle" />
      <NumberField source="sortOrder" />
      <BooleanField source="isActive" />
      <DateField source="createdAt" showTime />
      <DateField source="updatedAt" showTime />
      <ShowButton />
      <EditButton />
      <DeleteButton mutationMode="pessimistic" />
    </Datagrid>
  </List>
);
